import React, { useEffect, useState } from "react";
import CartItem from "./CartItemCard";
import { Close, LocalOffer } from "@mui/icons-material";
import { teal } from "@mui/material/colors";
import { Button, IconButton, TextField } from "@mui/material";
import PricingCard from "./PricingCard";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../State/Store";
import { fetchUserCart } from "../../../State/customer/cartSlice";

const Cart = () => {
  const [couponCode, setCouponCode] = useState("");
  const navigate = useNavigate();

  const { cart } = useAppSelector((store) => store);
  const dispatch = useAppDispatch();

  useEffect(() => {
    const jwt = localStorage.getItem("jwt");
    dispatch(fetchUserCart(jwt));
  }, [dispatch]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCouponCode(e.target.value);
  };

  const cartItems = cart.cart?.cartItems || [];

  const handleCheckout = () => {
    const jwt = localStorage.getItem("jwt");
    if (!jwt) {
      // Redirect unauthenticated user to login, passing the checkout return route
      navigate("/login?redirect=checkout");
      return;
    }
    navigate("/checkout");
  };

  return (
    <div className="pt-10 px-5 sm:px-10 md:px-60 min-h-screen">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
        {/* Cart Items Section */}
        <div className="cartItemSection lg:col-span-2 space-y-3">
          {cartItems.length > 0 ? (
            cartItems.map((item) => (
              <CartItem key={item.id || item.product?.id} item={item} />
            ))
          ) : (
            <div className="text-center p-10 border rounded-md bg-gray-50/50">
              <p className="text-gray-500 font-medium">
                Your cart is currently empty.
              </p>
              <Button
                onClick={() => navigate("/")}
                variant="text"
                sx={{ mt: 1, color: teal[600] }}
              >
                Continue Shopping
              </Button>
            </div>
          )}
        </div>

        {/* Pricing Column */}
        <div className="col-span-1 text-sm space-y-3">
          <div className="border rounded-md px-5 py-3 space-y-5">
            <div className="flex gap-3 text-sm items-center">
              <LocalOffer sx={{ color: teal[600], fontSize: "17px" }} />
              <span>Apply Coupons</span>
            </div>
            <div className="flex justify-between items-center">
              <TextField
                onChange={handleChange}
                id="outlined-basic"
                placeholder="coupon code"
                size="small"
                variant="outlined"
              />
              <Button size="small" sx={{ color: teal[700] }}>
                Apply
              </Button>
            </div>
          </div>

          <div className="border rounded-md">
            <PricingCard />
            <div className="p-5">
              <Button
                onClick={handleCheckout}
                fullWidth
                variant="contained"
                sx={{
                  py: "11px",
                  bgcolor: teal[600],
                  "&:hover": { bgcolor: teal[700] },
                }}
                disabled={cartItems.length === 0}
              >
                Buy now
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cart;